import { createTranslator, type MessageCatalog } from '@shigo-ui/i18n';

import enUSMessages from '../locales/en-US.json';

export const DASHBOARD_LOCALE = 'en-US';

export const dashboardMessages = enUSMessages satisfies MessageCatalog;

type PluralCategory = 'zero' | 'one' | 'two' | 'few' | 'many' | 'other';
type DashboardMessageCatalogKey = Extract<keyof typeof dashboardMessages, string>;
type PluralMessageKey<TKey extends string> = TKey extends `${infer Base}_${PluralCategory}`
  ? Base
  : never;
type DashboardPluralMessageKey = PluralMessageKey<DashboardMessageCatalogKey>;

export type DashboardMessageKey = DashboardMessageCatalogKey | DashboardPluralMessageKey;
export type DashboardMessageParams = Record<string, string | number>;
export type DashboardTranslate = (
  key: DashboardMessageKey,
  params?: DashboardMessageParams,
) => string;

const translate = createTranslator(dashboardMessages, { locale: DASHBOARD_LOCALE });

export function dashboardT(key: DashboardMessageKey, params?: DashboardMessageParams) {
  return translate(key, params);
}

export function createDashboardTranslator(_locale: string = DASHBOARD_LOCALE): DashboardTranslate {
  return dashboardT;
}
